import React from "react";
import styled from "styled-components";

const ImageIcon = styled.img`
  height: 18px;
  width: auto !important;
  vertical-align: top;
`;

interface IProps {
  iconStyle?: "fas" | "far" | "fal" | "fab";
  icon: string;
  isImage?: boolean;
  style?: React.CSSProperties;
}

const IconControl = (props: IProps) => {
  const style: React.CSSProperties = props.style || { marginRight: 6 };

  const icon = (
    <i
      style={style}
      className={`${props.iconStyle || "fas"} fa-${props.icon}`}
    />
  );
  const imageIcon = (
    <ImageIcon style={style} src={`/assets/svg/${props.icon}.svg`} />
  );

  return props.isImage ? imageIcon : icon;
};

export default IconControl;
